export default __webpack_public_path__ + "static/Profile-MeltingIce-4180f19fb871713015936838e163207b.png";